import { useState, useCallback, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import { toastApiError } from "../../utils/toastApiError";
import './GetInTouchForm.css';
import commissionImage from '../assets/commission_structure.png';

const initialFormValues = {
  company: "",
  name: "",
  email: "",
  message: "",
};

const GetInTouchForm = () => {
  const [form, setForm] = useState({ ...initialFormValues });
  const [captcha, setCaptcha] = useState(false);
  const [success, setSuccess] = useState(false);
  const reCaptchaRef = useRef(null);

  const handleChange = useCallback(
    (e) => {
      setForm({
        ...form,
        [e.target.name]: e.target.value,
      });
    },
    [form]
  );

  const handleCaptchaChange = useCallback((e) => {
    setCaptcha(e);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (captcha) {
      try {
        await axios.post(`/api/v3/messages/contact-us`, {
          ...form,
          gRecaptchaResponse: captcha,
        });
        setSuccess(true);
        setForm({ ...initialFormValues });
      } catch (err) {
        setSuccess(false);
        toastApiError(err);
      } finally {
        reCaptchaRef.current?.reset();
      }
    }
  };

  return (
    <div className="get-in-touch-wrapper" id="section-contact">
      <h2 className="get-in-touch-wrapper__title">GET IN TOUCH</h2>
      <div className="get-in-touch">
        <div className="get-in-touch__left">
          <div className="get-in-touch__image-card">
            <h3 className="get-in-touch__card-title">Have a question?</h3>
            <p className="get-in-touch__card-text">
              You can reach our dedicated affiliate team via our live chat system or through the contact form below. 
              Alternatively, please email <strong>affiliates@winningpartner.com</strong>
            </p>
          </div>
        </div>
        <div className="get-in-touch__right">
          {success && (
            <p className="get-in-touch__success">
              Your message has been sent, we'll get back to you within 24 hours
            </p>
          )}
          <form onSubmit={handleSubmit} className="get-in-touch__form">
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Name"
              required
            />
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email"
              required
            />
            <input
              type="text"
              name="company"
              value={form.company}
              onChange={handleChange}
              placeholder="Company"
              required
            />
            <textarea
              name="message"
              onChange={handleChange}
              value={form.message}
              placeholder="Message"
              rows="5"
            />
            <div className="get-in-touch__bottom-row">
              <div className="get-in-touch__recaptcha">
                <ReCAPTCHA
                  ref={reCaptchaRef}
                  sitekey="6Lc6O9AUAAAAAF6myYURrvZwW43E4ShPeKOVKCHe"
                  onChange={handleCaptchaChange}
                />
              </div>
              <button type="submit" className="get-in-touch__submit">
                Send message
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GetInTouchForm;
